export type CSSVariables =
	| 'red'
	| 'green'
	| 'white'
	| 'white-90'
	| 'white-80'
	| 'white-70'
	| 'white-60'
	| 'white-50'
	| 'white-40'
	| 'white-30'
	| 'white-20'
	| 'white-10'
	| 'black'
	| 'orange'
	| 'beruza-10'
	| 'beruza-20'
	| 'beruza-30'
	| 'beruza-40'
	| 'beruza-50'
	| 'beruza-60'
	| 'beruza-70'
	| 'beruza-80'
	| 'neoblue-10'
	| 'neoblue-20'
	| 'neoblue-30'
	| 'neoblue-40'
	| 'neoblue-50'
	| 'neoblue-60'
	| 'neoblue-70'
	| 'neoblue-80'
	| 'neoblue-90'
	| 'neoblue-100'
	| 'neoblue-110'
	| 'neoblue-120'
	| 'neoblue-130'
	| 'lightblue-10'
	| 'lightblue-20'
	| 'lightblue-20-alpha30'
	| 'lightblue-30'
	| 'lightblue-40'
	| 'lightblue-40-alpha10'
	| 'lightblue-40-alpha15'
	| 'lightblue-40-alpha80'
	| 'lightblue-50'
	| 'lightblue-50-alpha50'
	| 'lightblue-60'
	| 'lightblue-70'
	| 'lightblue-80'
	| 'lightblue-90'
	| 'lightblue-100'
	| 'lightblue-110'
	| 'lightblue-120'
	| 'lightblue-130'
	| 'lightblue-140'
	| 'darkblue-10'
	| 'darkblue-20'
	| 'darkblue-30'
	| 'darkblue-40'
	| 'darkblue-50'
	| 'darkblue-60'
	| 'darkblue-70'
	| 'darkblue-80'
	| 'darkblue-90'
	| 'darkblue-100'
	| 'darkblue-110'
	| 'darkblue-120'
	| 'darkblue-130'
	| 'darkblue-140'
	| 'pink-10'
	| 'pink-20'
	| 'pink-30'
	| 'pink-40'
	| 'pink-50'
	| 'pink-60'
	| 'pink-70'
	| 'pink-80'
	| 'pink-90'
	| 'pink-100'
	| 'pink-110'
	| 'pink-120'
	| 'pink-130'
	| 'pink-140'
	| 'beruza-dark-20'
	| 'beruza-dark-30'
	| 'beruza-dark-40'
	| 'beruza-dark-50'
	| 'beruza-dark-60'
	| 'beruza-dark-70'
	| 'beruza-dark-80';

export const CSS_VARIABLES_META: { [key in CSSVariables]: string } = {
	'beruza-10': 'var(--beruza-10)',
	'beruza-20': 'var(--beruza-20)',
	'beruza-30': 'var(--beruza-30)',
	'beruza-40': 'var(--beruza-40)',
	'beruza-50': 'var(--beruza-50)',
	'beruza-60': 'var(--beruza-60)',
	'beruza-70': 'var(--beruza-70)',
	'beruza-80': 'var(--beruza-80)',
	'beruza-dark-20': 'var(--beruza-dark-20)',
	'beruza-dark-30': 'var(--beruza-dark-30)',
	'beruza-dark-40': 'var(--beruza-dark-40)',
	'beruza-dark-50': 'var(--beruza-dark-50)',
	'beruza-dark-60': 'var(--beruza-dark-60)',
	'beruza-dark-70': 'var(--beruza-dark-70)',
	'beruza-dark-80': 'var(--beruza-dark-80)',
	black: 'var(--black)',
	'darkblue-10': 'var(--darkblue-10)',
	'darkblue-100': 'var(--darkblue-100)',
	'darkblue-110': 'var(--darkblue-110)',
	'darkblue-120': 'var(--darkblue-120)',
	'darkblue-130': 'var(--darkblue-130)',
	'darkblue-140': 'var(--darkblue-140)',
	'darkblue-20': 'var(--darkblue-20)',
	'darkblue-30': 'var(--darkblue-30)',
	'darkblue-40': 'var(--darkblue-40)',
	'darkblue-50': 'var(--darkblue-50)',
	'darkblue-60': 'var(--darkblue-60)',
	'darkblue-70': 'var(--darkblue-70)',
	'darkblue-80': 'var(--darkblue-80)',
	'darkblue-90': 'var(--darkblue-90)',
	green: 'var(--green)',
	'lightblue-10': 'var(--lightblue-10)',
	'lightblue-100': 'var(--lightblue-100)',
	'lightblue-110': 'var(--lightblue-110)',
	'lightblue-120': 'var(--lightblue-120)',
	'lightblue-130': 'var(--lightblue-130)',
	'lightblue-140': 'var(--lightblue-140)',
	'lightblue-20': 'var(--lightblue-20)',
	'lightblue-20-alpha30': 'var(--lightblue-20-alpha30)',
	'lightblue-30': 'var(--lightblue-30)',
	'lightblue-40': 'var(--lightblue-40)',
	'lightblue-40-alpha10': 'var(--lightblue-40-alpha10)',
	'lightblue-40-alpha15': 'var(--lightblue-40-alpha15)',
	'lightblue-40-alpha80': 'var(--lightblue-40-alpha80)',
	'lightblue-50': 'var(--lightblue-50)',
	'lightblue-50-alpha50': 'var(--lightblue-50-alpha50)',
	'lightblue-60': 'var(--lightblue-60)',
	'lightblue-70': 'var(--lightblue-70)',
	'lightblue-80': 'var(--lightblue-80)',
	'lightblue-90': 'var(--lightblue-90)',
	'neoblue-10': 'var(--neoblue-10)',
	'neoblue-100': 'var(--neoblue-100)',
	'neoblue-110': 'var(--neoblue-110)',
	'neoblue-120': 'var(--neoblue-120)',
	'neoblue-130': 'var(--neoblue-130)',
	'neoblue-20': 'var(--neoblue-20)',
	'neoblue-30': 'var(--neoblue-30)',
	'neoblue-40': 'var(--neoblue-40)',
	'neoblue-50': 'var(--neoblue-50)',
	'neoblue-60': 'var(--neoblue-60)',
	'neoblue-70': 'var(--neoblue-70)',
	'neoblue-80': 'var(--neoblue-80)',
	'neoblue-90': 'var(--neoblue-90)',
	orange: 'var(--orange)',
	'pink-10': 'var(--pink-10)',
	'pink-100': 'var(--pink-100)',
	'pink-110': 'var(--pink-110)',
	'pink-120': 'var(--pink-120)',
	'pink-130': 'var(--pink-130)',
	'pink-140': 'var(--pink-140)',
	'pink-20': 'var(--pink-20)',
	'pink-30': 'var(--pink-30)',
	'pink-40': 'var(--pink-40)',
	'pink-50': 'var(--pink-50)',
	'pink-60': 'var(--pink-60)',
	'pink-70': 'var(--pink-70)',
	'pink-80': 'var(--pink-80)',
	'pink-90': 'var(--pink-90)',
	red: 'var(--red)',
	white: 'var(--white)',
	'white-10': 'var(--white-10)',
	'white-20': 'var(--white-20)',
	'white-30': 'var(--white-30)',
	'white-40': 'var(--white-40)',
	'white-50': 'var(--white-50)',
	'white-60': 'var(--white-60)',
	'white-70': 'var(--white-70)',
	'white-80': 'var(--white-80)',
	'white-90': 'var(--white-90)',
};
